import {Component} from 'panel';

import template from './index.jade';
import css from './index.styl?inline';

export class CreateAnnotationButton extends Component<EmptyObj> {
  get config() {
    return {
      css,
      useShadowDom: true,
      template,
    };
  }
}
customElements.define(`create-annotation-button`, CreateAnnotationButton);
